import './index.scss'
import data from './data.json'
import Logo from '../../../assets/images/logo.svg'
import Spinner from '../../../assets/images/spinner.svg'
import {ArrowDownIcon, ArrowLeftIcon, ArrowUpIcon} from '../../../icons'
import SkeletonLoader from '../../core/skeletonLoader'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {routes} from '../../../routes'
import {ResponsivePageTitle} from '../../core/title'
import {Fragment} from 'react'

const LoaderScreen = () => {
    const loaderText = useSelector(state => state.auth.loaderText)

    const generateSidebarMenu = () => {
        return (
            <div className="navbar">
                <ul className="nav" id='nav'>
                    {data.menu.map((item, index) => (
                        <Fragment key={index}>
                            <li className="nav-item">
                                <SkeletonLoader/>
                            </li>
                            <ul className="nav-sub-items" id='nav-sub-items'>
                                {item.submenu.map((child, index) => (
                                    <li className="nav-sub-item" key={index}>
                                        <SkeletonLoader/>
                                    </li>
                                ))}
                            </ul>
                        </Fragment>
                    ))}
                </ul>
            </div>
        )
    }

    return (
        <div className="loader-overlay">
            <div className="container">
                <aside className="sidebar">
                    <div className="logo">
                        <Link to={routes.resources.path}><img width="116" height="31" src={Logo} alt="Pinghome"/></Link>
                    </div>
                    {generateSidebarMenu()}
                    <div id="user-account" className="account">
                        <div className="account-info">
                            <span className="cover">
                                <SkeletonLoader/>
                            </span>
                            <span className="name">
                                <SkeletonLoader/>
                            </span>
                        </div>
                        <div className="arrows">
                            <span>
                                <ArrowUpIcon/>
                            </span>
                            <span>
                                <ArrowDownIcon/>
                            </span>
                        </div>
                    </div>
                    <div className="toggle-btn">
                        <div className="close-sidebar">
                            <ArrowLeftIcon/>
                        </div>
                    </div>
                </aside>
                <main className="main">
                    <div>
                        <div className="content-title">
                            <div className="left-side">
                                <ResponsivePageTitle/>
                                <div>
                                    <div className="section">
                                        <SkeletonLoader/>
                                    </div>
                                    <h1 className="page-title">
                                        <SkeletonLoader/>
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div className="content-body">
                            <img width="auto" height="auto" className="spinner" src={Spinner} alt="Pinghome"/>
                            <p>{loaderText}</p>
                        </div>
                    </div>
                    <footer className="footer">
                        <ul>
                            {data.footer_menu.map((item, index) => (
                                <li key={index}>
                                    <SkeletonLoader/>
                                </li>
                            ))}
                        </ul>
                        <div>
                            <SkeletonLoader/>
                        </div>
                    </footer>
                </main>
            </div>
        </div>
    )
}

export default LoaderScreen
